// Google Fonts for engraving preview
(function() {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script&family=Libre+Baskerville&family=Special+Elite&family=Josefin+Sans&display=swap';
  document.head.appendChild(link);
})();

const ENGRAVING_VARIANT_ID = '54493734109530';
const MAX_CHARS = 10;

const fontMap = {
  'Calligraphy': "'Dancing Script', cursive",
  'Sans Serif': "'Libre Baskerville', serif",
  'Engravers': "'Special Elite', cursive",
  'Futura': "'Josefin Sans', sans-serif",
  'Bahuhaus': "'Josefin Sans', sans-serif",
  'Segoe Print': "'Segoe Print', cursive"
};

function initEngraving() {
  const btn = document.querySelector('.engraving-btn');
  if (!btn) return;

  const overlay = document.getElementById('engraving-overlay');
  const cancelBtn = document.getElementById('engraving-cancel');
  const addBtn = document.getElementById('engraving-add');
  const fontSelect = document.getElementById('engraving-font');
  const textInput = document.getElementById('engraving-text');
  const preview = document.getElementById('engraving-preview');
  const counter = document.getElementById('engraving-counter');

  btn.addEventListener('click', function() {
    overlay.classList.add('active');
  });

  cancelBtn.addEventListener('click', function() {
    closeModal();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });

  fontSelect.addEventListener('change', updatePreview);

  textInput.addEventListener('input', function() {
    if (this.value.length > MAX_CHARS) {
      this.value = this.value.slice(0, MAX_CHARS);
    }
    const left = MAX_CHARS - this.value.length;
    counter.textContent = left + ' MERKKIÄ JÄLJELLÄ';
    updatePreview();
  });

  function updatePreview() {
    const font = fontMap[fontSelect.value] || 'sans-serif';
    preview.style.fontFamily = font;
    preview.textContent = textInput.value || '';
  }

  addBtn.addEventListener('click', function() {
    const text = textInput.value.trim();
    const font = fontSelect.value;

    if (!text) {
      alert('Kirjoita kaiverrasteksti ennen lisäämistä.');
      return;
    }

    const variantInput = document.querySelector('[name="id"]');
    const productVariantId = variantInput ? variantInput.value : null;

    if (!productVariantId) {
      alert('Tuotevarianttia ei löydy. Yritä uudelleen.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(productVariantId),
            quantity: 1,
            properties: {
              'Kaiverrasteksti': text,
              'Fontti': font
            }
          },
          {
            id: parseInt(ENGRAVING_VARIANT_ID),
            quantity: 1,
            properties: {
'Kaiverrus tuotteelle': (function() {
  var titleEl = document.querySelector('.product__title h1, h1.product__title');
  var skuEl = document.querySelector('[data-variant-sku]');
  var title = titleEl ? titleEl.textContent.trim() : '';
  var sku = skuEl ? skuEl.textContent.trim() : '';
  return (title && sku) ? title + ' - ' + sku : title || '';
})()
            }
          }
        ]
      })
    })
    .then(res => res.json())
    .then(function(data) {
      if (data.status) {
        alert('Virhe: ' + (data.description || 'Tuntematon virhe'));
      } else {
        closeModal();
        window.location.href = '/cart';
      }
    })
    .catch(function() {
      alert('Verkkovirhe. Yritä uudelleen.');
    });
  });

  function closeModal() {
    overlay.classList.remove('active');
  }
}

document.addEventListener('DOMContentLoaded', initEngraving);
